import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import Header from 'field/common/Header';
import { redirectIFrame } from 'helpers/iframeHelpers';
import LocaleContext from 'constants/localization';

export default function SearchLink({field}) {
  const LS = useContext(LocaleContext);
  const searchValue = useSelector(state => state.object.uri);
  const count = field.props.count;
  const topLevel = field.props.topLevel;
  const searchKey = field.props.searchKey;
  const orderByPredicate = field.props.orderByPredicate;

  let searchView = 'object';

  if (field.props.searchView) {
    searchView = field.props.searchView;
  }

  const params = new URLSearchParams({
    topLevel,
    searchKey,
    searchValue,
    orderByPredicate,
    forceExecute: true,
    searchView,
    style: 'simple',
    negativeSearch: 'no',
	isSearchLink: true,
    constraint: 'grandParent->http://www.profium.com/archive/Folder/universalParent'
  }).toString();

  return (
    <div className="field row" >
      <Header field={field} />
      <a href="#" onClick={e => {
        e.preventDefault();
        redirectIFrame(`search.do?${params}`);
      }}>
        {count} {LS.targets}
      </a>
    </div>
  );
}

export const isSearchLink = field => {
  return field.props && field.props.count && field.values.length === 0;
};
